import { create } from 'zustand';
import { AdditionalInformations } from '../modules/validateRules';

interface GenericModals {
  genericModals: AdditionalInformations[] | null;
  setGenericModals: (props: AdditionalInformations[]) => void;
  clearGenericModals: () => void;
}

export const useGenericModals = create<GenericModals>(set => ({
  genericModals: null,
  setGenericModals: genericModals =>
    set({
      genericModals
    }),
  clearGenericModals: () => set({ genericModals: null })
}));
